import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import LoginModal from "../components/LoginModal";
import RegistrationModal from "../components/RegistrationModal";

function Header() {
  const navbarRef = useRef(null);
  useEffect(() => {
  const handleClickOutside = (event) => {
    const navbar = document.getElementById("navbarSupportedContent");

    if (
      navbar &&
      navbar.classList.contains("show") &&
      navbarRef.current &&
      !navbarRef.current.contains(event.target)
    ) {
      const collapse = window.bootstrap.Collapse.getInstance(navbar);

      if (collapse) {
        collapse.hide();
      }
    }
  };

  document.addEventListener("click", handleClickOutside);

  return () => {
    document.removeEventListener("click", handleClickOutside);
  };
}, []);
const closeMenu = () => {
  const navbar = document.getElementById("navbarSupportedContent");

  if (navbar && navbar.classList.contains("show")) {
    const collapse = window.bootstrap.Collapse.getOrCreateInstance(navbar);
    collapse.hide();
  }
};
  return (
    <>
    <div className="sticky-top">
      <header className="inner-header">
        <nav ref={navbarRef} className="navbar navbar-expand-lg bg-body-tertiary main-navbar">
          <div className="container">

            {/* Logo */}
            <Link
              className="navbar-brand d-flex align-items-center"
              to="/" onClick={closeMenu}
            >
              <img
                className="logo"
                src={`${process.env.PUBLIC_URL}/assets/imgs/Logo.png`}
                alt="Logo"
              />
            </Link>

            {/* Mobile Toggle */}
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
                <li className="nav-item">
                  <Link className="nav-link" to="/" onClick={closeMenu}>
                    Home
                  </Link>
                </li>

                <li className="nav-item">
                  <Link className="nav-link" to="/AboutUs" onClick={closeMenu}>
                    Our Story
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/ServicesListing" onClick={closeMenu}>
                    Services
                  </Link>
                </li>
               {/*  <li className="nav-item">
                  <Link className="nav-link" to="/Adoption" onClick={closeMenu}>
                  Adoption
                  </Link>
                </li>
                
                <li className="nav-item">
                  <Link className="nav-link" to="/PetRegistration" onClick={closeMenu}>
                    Pet Registration
                  </Link>
                </li>*/}

                <li className="nav-item">
                  <Link className="nav-link" to="/ContactUs" onClick={closeMenu}>
                    Contact Us
                  </Link>
                </li>
                {/* <li className="nav-item">
                  <Link className="nav-link" to="/YourStory" onClick={closeMenu}>
                    Your Story 
                  </Link>
                </li> */}
                 <li className="nav-item">
                  <Link className="nav-link"  data-bs-toggle="modal" data-bs-target="#RegistrationModal" onClick={closeMenu}>
                    Sign Up
                  </Link>
                </li>
                 {/*  <li className="nav-item">
                  <Link className="nav-link" data-bs-toggle="modal" data-bs-target="#loginModal" onClick={closeMenu}>
                    Login
                  </Link>
                </li>*/}
              </ul>

              {/* Static User Profile 
              <div className="d-flex">
                <div className="dropdown-center">
                  <div
                    className="loign_user dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      className="login_user_profile"
                      src={`${process.env.PUBLIC_URL}/assets/imgs/default_user.jpeg`}
                      alt="User"
                      style={{
                        objectFit: "cover",
                        borderRadius: "50%",
                      }}
                    />
                    <h5 className="login_user_profile_name">
                      John Doe
                    </h5>
                  </div>

                  <ul className="dropdown-menu dropdown-menu-end shadow-sm">
                    <li>
                      <Link
                        className="dropdown-item py-2"
                        to="/dashboard"
                      >
                        <i className="fa-regular fa-user me-2 text-secondary"></i>
                        My Dashboard
                      </Link>
                    </li>

                    <li>
                      <hr className="dropdown-divider" />
                    </li>

                    <li>
                      <Link
                        className="dropdown-item py-2 text-danger fw-bold"
                        to="/"
                      >
                        <i className="fa-solid fa-arrow-right-from-bracket me-2"></i>
                        Logout
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>*/}

            </div>
          </div>
        </nav>
      </header>
      
    </div>
     <LoginModal />
     <RegistrationModal />
    </>
  );
}

export default Header;